import { PlusOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import React, { useState } from 'react'
import FinYearList from './adminconfig/finyear/FinYearList';
import AddFinYear from './adminconfig/finyear/AddFinYear';

function FinYearView () {

  const [visible, setVisible] = useState(false);
const [hasUpdated, setHasUpdated] = useState(true);

const handleUpdates = (updated)=> {
  setHasUpdated(updated)
}

const showModal = (value) => {
    setVisible(value);
};
  return (
    <>
    <div className="content">
        <Col xs={24}>
            <h1 className="center-align">Manage Financial Year</h1>
        </Col>
        <Button
            className="add-button"
            key="1"
            type="primary"
            onClick={() => showModal(true)}
            icon={<PlusOutlined />}
        >
            {""} Add New
        </Button>
        <AddFinYear key={"a2"} show={visible} onShow={showModal} setHasUpdated={handleUpdates}/>
        <FinYearList hasUpdated={hasUpdated} setHasUpdated={handleUpdates}/>
    </div>
</>
  )
}

export default FinYearView
